import React from 'react';

import styled from 'styled-components';

import { ShopperEmailsContext } from './ShopperEmailsContext';
import ShopperEmailsData from './ShopperEmailsData';
import ShopperEmailsEntryModal from './ShopperEmailsEntryModal';
import ShopperEmailsHeader from './ShopperEmailsHeader';
import { useShopperEmailsMailboxActions } from './useShopperEmailsMailboxActions';
import { useShopperEmailsPage } from './useShopperEmailsPage';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const ShopperEmails = () => {
  const {
    entryModal,
    items,
    loading,
    totalItemsCount,
    filters,
    setPage,
    setFilters,
    openCreateModal,
    openEditModal,
    closeEntryModal,
    refetchShopperEmails,
  } = useShopperEmailsPage();
  const { authenticatingEmailId, handleMailboxAction } = useShopperEmailsMailboxActions(refetchShopperEmails);

  return (
    <ShopperEmailsContext.Provider
      value={{
        items,
        loading,
        totalItemsCount,
        filters,
        authenticatingEmailId,
        setPage,
        setFilters,
        openCreateModal,
        openEditModal,
        onMailboxAction: handleMailboxAction,
      }}
    >
      <Container>
        <ShopperEmailsHeader />
        <ShopperEmailsData />
        <ShopperEmailsEntryModal open={entryModal.open} item={entryModal.item} onCancel={closeEntryModal} />
      </Container>
    </ShopperEmailsContext.Provider>
  );
};

export default ShopperEmails;
